import { Component, OnDestroy, OnInit } from '@angular/core';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';

import { OneSignal } from '@awesome-cordova-plugins/onesignal/ngx';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { LoginService, UserService } from 'src/app/services';
import { CustomValidator } from 'src/app/utilities/custom-validator';
import { ToastService } from 'src/app/utilities/toast.service';
import { Stylist } from 'src/app/models';
import {
  AlertController,
  LoadingController,
  NavController,
  NavParams,
  Platform,
} from '@ionic/angular';
import { ENV_CONFIG } from '../../bin/env.config';
// import {
//   ActionPerformed,
//   PushNotificationSchema,
//   PushNotifications,
//   Token,
// } from '@capacitor/push-notifications';
// import posthog from 'posthog-js';
declare let FB: any;
declare var posthog: any;
@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit, OnDestroy {
  public submitted: boolean;

  public loginForm: UntypedFormGroup;

  public emailField: UntypedFormControl;

  public passwordField: UntypedFormControl;

  public backGroundImageToShow;

  public greeting: string;

  public errorMessage = '';

  public loginError = false;

  public showPassword: boolean = false;

  public appVersion: string = ENV_CONFIG.appVersion;

  successPageAfterLogin = '/bookings'; // 'booking-calendar'

  isFormInput: boolean = false;

  constructor(
    private navCtrl: NavController,
    private alertCtrl: AlertController,
    private formBuilder: UntypedFormBuilder,
    private loginService: LoginService,
    private loadingCtrl: LoadingController,
    private userService: UserService,
    private platform: Platform,
    private inAppBrowser: InAppBrowser,
    private readonly toastService: ToastService,
  ) {
    this.submitted = false;
    this.emailField = new UntypedFormControl();
    this.passwordField = new UntypedFormControl();
    this.loginForm = this.formBuilder.group({
      email: this.emailField,
      password: this.passwordField,
    });
  }

  // ionViewCanEnter should be replaced by angular route lifecycle canActivate
  // public ionViewCanEnter () {
  //   if (this.userService.isLoggedIn()) {
  //     setTimeout(() => {
  //       this.navCtrl.navigateRoot(this.successPageAfterLogin);
  //     }, 100);
  //     return false;
  //   }

  //   return true;
  // }

  public ngOnInit() {
    if (this.userService.isLoggedIn()) {
      setTimeout(() => {
        this.navCtrl.navigateRoot(this.successPageAfterLogin);
      }, 100);
      return false;
    }
    else {
      this.userService.clearSession();
    }
    this.userService.setSideBarVisiblity(false);
    this.backGroundImageToShow = `bg${Math.floor(Math.random() * 4) + 1}`;

    // // Request permission to use push notifications
    // // iOS will prompt user and return if they granted permission or not
    // // Android will just grant without prompting
    // PushNotifications.requestPermissions().then(result => {
    //   if (result.receive === 'granted') {
    //     // Register with Apple / Google to receive push via APNS/FCM
    //     PushNotifications.register();
    //   } else {
    //     // Show some error
    //   }
    // });

  }

  emailFocus() {
    this.emailField.setValidators(Validators.compose([Validators.required, CustomValidator.validateEmail]))
  }

  passwordFocus() {
    this.passwordField.setValidators(Validators.required)
    this.isFormInput = true
  }

  public ngOnDestroy() {
    this.userService.setSideBarVisiblity(true);
  }

  public async onLogin() {
    this.hideLoginError();
    this.submitted = true;

    if (this.loginForm.valid === false) {
      return;
    }

    const email = this.emailField.value;
    const password = this.passwordField.value;
    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();
    this.loginService.loginUser(email, password).subscribe({
      next: async (response) => {
        if (response) {
          if (response.salon['appVersion'] < 6) {
            if (this.platform.is('capacitor')) {
              let appStoreLink = '';

              if (this.platform.is('ios')) {
                appStoreLink = `https://itunes.apple.com/us/app/salonmonster-salon-and-spa-booking-and-management/id988908802?mt=8`;
              } else {
                appStoreLink = `https://play.google.com/store/apps/details?id=com.salonmonster.app&hl=en`;
              }

              // redirect to the app store
              this.alertCtrl
                .create({
                  message: `Oops, looks like you are on our Classic account.`,
                  buttons: [
                    {
                      text: 'Ok',
                      handler: () => {
                        this.inAppBrowser.create(appStoreLink, '_system');
                      },
                    },
                  ],
                })
                .then((alert) => alert.present());

              return;
            } else {
              // redirect to the classic salonMonster app web version
              const form = document.createElement('form');
              document.body.appendChild(form);
              form.method = 'post';
              form.action =
                'https://salonmonster.com/external_process_login.php';

              const input = document.createElement('input');
              input.type = 'hidden';
              input.name = 'email';
              input.value = email;
              form.appendChild(input);

              const input2 = document.createElement('input');
              input2.type = 'hidden';
              input2.name = 'password';
              input2.value = password;
              form.appendChild(input2);

              const input3 = document.createElement('input');
              input3.type = 'hidden';
              input3.name = 'remember';
              input3.value = 'yes';
              form.appendChild(input3);
              form.submit();
              return;
            }
          }

          this.userService.login(response);
          if (this.platform.is('capacitor')) {
            const stylistID = response.user['id'].toString();
            if (stylistID && typeof stylistID === 'string' && stylistID.trim() !== '') {
              try {
                await FirebaseMessaging.subscribeToTopic({ topic: stylistID });
              } catch (error) {
                console.error(error);
              }
            } else {
              console.error('Invalid stylistID');
            }
          }

          if (!this.userService.getUser().isActive()) {
            this.alertCtrl
              .create({
                message: `Your account is currently inactive. Please contact your salon administrator to re-activate your account.`,
                buttons: ['Ok'],
              })
              .then((alert) => alert.present());
            this.userService.logout();
          } else {
            this.navCtrl.navigateRoot(this.successPageAfterLogin);
          }
        }

        loader.dismiss();
      },
      error: (error) => {
        loader.dismiss().then(() => {
          // this.setLoginError(error.err_msg);
          this.toastService.presentSimpleToast(
            `Oops, the email and password entered don't match.`,
            5000,
            'top',
            'danger'
          );
        });
      },
    });
  }

  public async onFacebookWebLogin() {
    this.hideLoginError();

    const loader = await this.loadingCtrl.create({ spinner: 'crescent' });
    loader.present();

    FB.login(
      (response: any) => {
        if (response.status === 'connected') {
          FB.api(
            '/me',
            { fields: 'first_name, last_name, email' },
            (userResponse) => {
              const id: string = userResponse['id'];
              const email: string = userResponse['email'];
              const firstName: string = userResponse['first_name'];
              const lastName: string = userResponse['last_name'];

              this.loginService.loginFacebookUser(id, email).subscribe({
                next: (_response) => {
                  loader.dismiss().then(() => {
                    this.userService.login(_response);

                    this.navCtrl.navigateRoot(this.successPageAfterLogin);
                  });
                },
                error: (error) => {
                  loader.dismiss().then(() => {
                    if (error.status === 404) {
                      // fb account and fb email not associated with any account yet
                      // move to sign up view with pre-filled stylist object
                      const stylist: Stylist = new Stylist({
                        id: undefined,
                        firstName,
                        lastName,
                        title: undefined,
                        email,
                        phone1: undefined,
                        phone2: undefined,
                        address1: undefined,
                        address2: undefined,
                        city: undefined,
                        province: undefined,
                        postal: undefined,
                        country: undefined,
                        active: undefined,
                        administrator: undefined,
                        isRebook: undefined,
                        suggestRebookingBeforeCheckout: undefined,
                        stylistKey: undefined,
                        confirmApptsManually: undefined,
                        calendar: undefined,
                        viewAllCalendars: undefined,
                        viewAllClients: undefined,
                        photoUrl: undefined,
                        hideDurations: undefined,
                        canPush: undefined,
                        settingsControl: undefined,
                        canViewReports: undefined,
                        cc: undefined,
                        allowBookingsUntil: undefined,
                        bookingHorizon: undefined,
                        sendAppointmentReminderBefore: undefined,
                        bookingInterval: undefined,
                        letClientsRegister: undefined,
                        letClientsCancel: undefined,
                        bookingIntro: undefined,
                        notifyForAllStaffActivity: undefined,
                        newBookingNotification: undefined,
                        editBookingNotification: undefined,
                        deleteBookingNotification: undefined,
                        waitListRequestNotification: undefined,
                        serviceDefinitions: undefined,
                        bookings: undefined,
                        areServiceDetailsLoaded: undefined,
                        cachedServiceDetailsOptionsEl: undefined,
                        intercomUserHash: undefined,
                        password: '',
                        abTest: undefined,
                        cancellationPolicy: undefined,
                        fbID: id,
                        waitingList: undefined,
                        allowCancellationUntil: '',
                        letClientsUseFBLogin: undefined,
                        minCancellation: '',
                        sort: undefined,
                        pronoun: undefined,
                        customPronoun: undefined,
                        isChatboxEnabled: true,
                        isChatBubbleEnabled: true,
                      });

                      this.navCtrl.navigateForward('SignUpSalonInfoPage', {
                        queryParams: { stylist },
                      });
                    } else {
                      // this.setLoginError(error.err_msg);
                    }
                  });
                }
              }
              );
            }
          );
        } else {
          loader.dismiss();
        }
      },
      {
        scope: 'public_profile, email',
        return_scopes: true,
      }
    );
  }

  // public onNewSignUp() {
  //   this.navCtrl.navigateForward('SignUpPersonalInfoPage', {
  //     queryParams: { planID: 2 },
  //   });
  // }

  // public onResetPassword() {
  //   this.navCtrl.navigateForward('PasswordResetRequestPage');
  // }

  public onTermsOfService() {
    const termsOfServiceLink = `https://salonmonster.com/terms-conditions/`;
    if (this.platform.is('capacitor')) {
      this.inAppBrowser.create(termsOfServiceLink, '_system');
    } else {
      window.open(termsOfServiceLink, "_blank").focus();
    }
  }

  public onPrivacyPolicy() {
    const privacyPolicyLink = `https://salonmonster.com/privacy-policy/`;
    if (this.platform.is('capacitor')) {
      this.inAppBrowser.create(privacyPolicyLink, '_system');
    } else {
      window.open(privacyPolicyLink, "_blank").focus();
    }
  }

  // setLoginError(message: string) {
  //   this.loginError = true;
  //   this.errorMessage = message;

  //   const signUpRegex = /sign up/gi;
  //   const forgotPasswordRegex = /forgot password/gi;
  //   const resetYourPasswordRegex = /reset your password/gi;
  //   const resetPasswordRegex = /reset password/gi;

  //   if (signUpRegex.test(this.errorMessage)) {
  //     this.errorMessage = this.errorMessage.replace(
  //       signUpRegex,
  //       '<span class="sm-login-error-message-button" id="sign-up-button"><strong>' +
  //         this.errorMessage.match(signUpRegex).concat()[0] +
  //         '</strong></span>'
  //     );
  //   } else if (forgotPasswordRegex.test(this.errorMessage)) {
  //     this.errorMessage = this.errorMessage.replace(
  //       forgotPasswordRegex,
  //       '<span class="sm-login-error-message-button" id="forgot-password-button"><strong>' +
  //         this.errorMessage.match(forgotPasswordRegex).concat()[0] +
  //         '</strong></span>'
  //     );
  //   } else if (resetYourPasswordRegex.test(this.errorMessage)) {
  //     this.errorMessage = this.errorMessage.replace(
  //       resetYourPasswordRegex,
  //       '<span class="sm-login-error-message-button" id="forgot-password-button"><strong>' +
  //         this.errorMessage.match(resetYourPasswordRegex).concat()[0] +
  //         '</strong></span>'
  //     );
  //   } else if (resetPasswordRegex.test(this.errorMessage)) {
  //     this.errorMessage = this.errorMessage.replace(
  //       resetPasswordRegex,
  //       '<span class="sm-login-error-message-button" id="forgot-password-button"><strong>' +
  //         this.errorMessage.match(resetPasswordRegex).concat()[0] +
  //         '</strong></span>'
  //     );
  //   }
  // }

  // loginErrorButton() {
  //   const signUpRegex = /sign up/gi;
  //   const forgotPasswordRegex = /forgot password/gi;
  //   const resetYourPasswordRegex = /reset your password/gi;
  //   const resetPasswordRegex = /reset password/gi;

  //   if (signUpRegex.test(this.errorMessage)) {
  //     this.onNewSignUp();
  //   } else if (
  //     forgotPasswordRegex.test(this.errorMessage) ||
  //     resetPasswordRegex.test(this.errorMessage) ||
  //     resetYourPasswordRegex.test(this.errorMessage)
  //   ) {
  //     this.onResetPassword();
  //   }
  // }

  hideLoginError() {
    this.loginError = false;
    this.errorMessage = '';
  }

  switchShowPassword() {
    this.showPassword = !this.showPassword;
  }
}
